export default {
    proposals_list(state){
        let temp = state.proposals_list
        return temp ? temp.response : null
    },
    current_proposal(state){
        let temp = state.current_proposal
        return temp ? temp : null
    },
    proposal: (state) => (id) => {
        if(state.proposals_list && state.proposals_list.response && state.proposals_list.response.mansioni){
            let t = state.proposals_list.response.mansioni.find(item => item.id == id)
            if(t){
                return JSON.parse(JSON.stringify(t))
            }
        }
        return null;
    },
};